import React, { useEffect, useState } from "react";
import API from "../../api";
import PropTypes from "prop-types";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import "rc-checkbox/assets/index.css";
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
const HistoriqueUser = props => {
  const [sections, setSections] = useState([]);
  const [dateDebut, setDateDebut] = useState(new Date())
  const [dateFin, setDateFin] = useState(new Date())
  const userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"));
  const annee_id = userAuthScolarite.user.annee_id;

  useEffect(() => {
    const fetchData = async () => {
      const url = window.location.href;
      const parts = url.split("=");
      const id = parts[1];
      try {
        const res = await API.post("master/get_by_user_id", { user_id: id, annee_id });
        setSections(res.data.Historique_user || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [annee_id]);

  // Fonction pour parser les cellules dynamiquement
  const parseCell = (value) => {
    try {
      if (typeof value === "string") {
        value = value.trim();
        if (value.startsWith("{") || value.startsWith("[")) {
          // JSON string
          return JSON.parse(value);
        }
        if (value.startsWith("<")) {
          // HTML string
          return { __html: value };
        }
      }
      return value;
    } catch {
      return value;
    }
  };
  const search = async () => {
    const url = window.location.href;
    const parts = url.split("=");
    const id = parts[1];
    if (dateDebut != "" && dateFin!="") {
      //date debut
      let DateNote_debut = dateDebut
      let month_debut = "" + (DateNote_debut.getMonth() + 1)
      let day_debut = "" + DateNote_debut.getDate()
      let year_debut = DateNote_debut.getFullYear()
      if (month_debut.length < 2) month_debut = "0" + month_debut
      if (day_debut.length < 2) day_debut = "0" + day_debut
      var convertDate_debut = [year_debut, month_debut, day_debut].join("-")
      ///date fin
      let DateNote_fin = dateFin
      let month_fin = "" + (DateNote_fin.getMonth() + 1)
      let day_fin = "" + DateNote_fin.getDate()
      let year_fin = DateNote_fin.getFullYear()
      if (month_fin.length < 2) month_fin = "0" + month_fin
      if (day_fin.length < 2) day_fin = "0" + day_fin
      var convertDate_fin = [year_fin, month_fin, day_fin].join("-")
      const res = await API.post("master/get_by_user_id", {
        user_id: id,
        annee_id,
        start_date: convertDate_debut,
        end_date: convertDate_fin,
      }).then(res => {
        setSections(res.data.Historique_user || []);
      })
    }else{
      toast.error("⛔ Date début et date fin sont obligatroire !", {
        containerId: "A",
      })
    }

  }

  const searchAll = async () => {
    const res = await API.post("master/get_by_user_id", { user_id: id, annee_id });
    setSections(res.data.Historique_user || []);
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                <CardTitle style={{ color: "#556ee6" }} className="h4">
                  Critéres de Recherches
                </CardTitle>
                <Form className="mt-4">
                  <Row>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-lastname-input2">Date Début :</Label>
                        <DatePicker
                          selected={dateDebut}
                          className="form-control ddate"
                          dateFormat="dd/MM/yyyy"
                          onChange={e => setDateDebut(e)}
                        />
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-lastname-input2">Date Fin :</Label>
                        <DatePicker
                          selected={dateFin}
                          className="form-control ddate"
                          dateFormat="dd/MM/yyyy"
                          onChange={e => setDateFin(e)}
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>
                <div
                  className="mb-4"
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  {" "}
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#761C19",
                          borderColor: "#761C19",
                        }}
                        className="btn btn-success mb-2 me-2"
                        onClick={search}
                      >
                        Rechercher
                      </button>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#761C19",
                          borderColor: "#761C19",
                        }}
                        className="btn btn-success mb-2 me-2"
                        onClick={searchAll}
                      >
                        Afficher tout
                      </button>
                    </div>
                  </Col>
                </div>
                <Row>
                  {sections.map((section, sIdx) => {
                    const rows = section.array || [];
                    const cols = rows.length > 0 ? Object.keys(rows[0]) : [];

                    return (
                      <div key={sIdx} className="mb-4">
                        <table className="table table-bordered ">
                          <thead>
                          <tr className="table-primary">
                            <th colSpan={Math.max(1, cols.length)} className="text-center">
                              {section.name}
                            </th>
                          </tr>
                          {cols.length > 0 && (
                            <tr>
                              {cols.map(c => (
                                <th key={c}>{c}</th>
                              ))}
                            </tr>
                          )}
                          </thead>

                          <tbody>
                          {rows.length === 0 ? (
                            <tr>
                              <td colSpan={Math.max(1, cols.length)} className="text-center text-muted">
                                Aucun enregistrement trouvé
                              </td>
                            </tr>
                          ) : (
                            rows.map((row, rIdx) => (
                              <tr key={rIdx}>
                                {cols.map(c => {
                                  const value = parseCell(row[c]);

                                  // HTML string
                                  if (value && value.__html) {
                                    return <td key={c} dangerouslySetInnerHTML={value} />;
                                  }

                                  // JSON object
                                  if (value && typeof value === "object") {
                                    const firstItem = Object.values(value)[0] || {};
                                    return (
                                      <td key={c}>
                                        <table className="table table-sm table-bordered mb-0">
                                          <thead>
                                          <tr>
                                            {Object.keys(firstItem).map((k) => (
                                              <th key={k}>{k}</th>
                                            ))}
                                          </tr>
                                          </thead>
                                          <tbody>
                                          {Object.values(value).map((item, idx) => (
                                            <tr key={idx}>
                                              {Object.values(item).map((v, i) => (
                                                <td key={i}>{v}</td>
                                              ))}
                                            </tr>
                                          ))}
                                          </tbody>
                                        </table>
                                      </td>
                                    );
                                  }

                                  // Valeur simple ou vide
                                  return <td key={c}>{value ?? "-"}</td>;
                                })}
                              </tr>
                            ))
                          )}
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
                </Row>

                <Row>
                  <Col lg="6" className="d-flex justify-content-end mt-4">
                    <Button
                      type="button"
                      color="warning"
                      className="btn btn-warning mb-2 me-2"
                      onClick={() => props.history.push("/User")}
                    >
                      {props.t("Annuler")}
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>

      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  );
};

export default withTranslation()(HistoriqueUser);

HistoriqueUser.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
};
